import DocumentTitle from 'react-document-title';

import GenericErrorBanner from 'hb-react/publicoffice/components/GenericErrorBanner';
import {
  ROUTE_TAG_CURRENT_NETWORK,
  ROUTE_TAG_LOGIN_SETTINGS,
} from 'hb-react/publicoffice/constants/routeTags';
import PublicOfficeApp from 'hb-react/publicoffice/providers/App';
import useNetworkConfiguration from 'hb-react/publicoffice/utils/useNetworkConfiguration';
import { generatePageTitle } from 'hb-react/shared/utils/generatePageTitle';

import Login from './components/Login';

// Constants to prevent re-creation on every render
const NETWORK_ROUTE_TAGS = [
  { routeTag: ROUTE_TAG_CURRENT_NETWORK },
  { routeTag: ROUTE_TAG_LOGIN_SETTINGS },
];

const LoginApp = ({ errors }) => {
  const { networkConfiguration, isError } = useNetworkConfiguration({
    styleNeeded: false,
    networkRouteTags: NETWORK_ROUTE_TAGS,
  });

  if (isError) {
    return <GenericErrorBanner />;
  }

  if (networkConfiguration) {
    const { colors, theming, currentNetwork, loginSettings } =
      networkConfiguration;

    const customNetwork = {
      colors: colors?.colors || {},
      theming: theming?.theming || {},
      ...currentNetwork,
    };

    return (
      <PublicOfficeApp network={customNetwork}>
        <DocumentTitle
          title={generatePageTitle({
            title: __('Login'),
            networkName: customNetwork.title,
          })}
        />
        <Login
          currentNetwork={customNetwork}
          errors={errors || []}
          settings={loginSettings.login}
        />
      </PublicOfficeApp>
    );
  }

  return null;
};

export default LoginApp;
